import { takeEvery } from 'redux-saga/effects'

import { GET_CAMPAIGNS } from 'Redux/actions/campaignActions'
import onGetCampaignsLists from './onGetCampaignsLists'

export default function*() {
  yield takeEvery(GET_CAMPAIGNS, onGetCampaignsLists)
}
